import { timeZone } from '@helios/ag-grid-config'
import { currentTimezoneConverter } from '@helios/utils'
import {
  DisplayDateTimeFormat,
  ISODateTimeFormat,
  formatDate,
} from '@northfork/basics'
import { parse } from 'date-fns'
import { format } from 'date-fns-tz'

/**
 * Format date in to given format.
 */
export function formatDates(
  dateString: string | undefined,
  currentDateFormat: string,
  expectedDateFormat: string,
): string {
  if (!dateString) {
    return ''
  }
  const date = parse(dateString, currentDateFormat, new Date())

  if (isNaN(date.getTime())) {
    return dateString
  }
  return format(date, expectedDateFormat, {
    timeZone: 'UTC',
  })
}
/**
 *Function to return date for tooltip
 */
export function formatDateTime(dateString: string | undefined): string {
  if (!dateString) {
    return ''
  }
  const date = formatDate(dateString, DisplayDateTimeFormat, ISODateTimeFormat)
  return date ? `${date} ${timeZone}` : ''
}

/**
 *Function to return date for tooltip
 */
export function convertTimezone(dateString: string): string {
  return currentTimezoneConverter(dateString)
}
